import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['title', 'description', 'primaryAction']> =
	defineContent({
		default: {
			title: {
				id: 'jira-plans-release-date-changeboarding.title',
				defaultMessage: 'Set a release date when you’re ready',
				description:
					'Heading explaining that users can choose when to set a fixed release date in Create release and Edit release dialogs.',
				role: 'title',
			},
			description: {
				id: 'jira-plans-release-date-changeboarding.description',
				defaultMessage:
					'You can leave the release date unset. Set a date to visualise this release in the Timeline section.',
				description:
					'Explains that release dates can now be left unset, and setting a date lets users visualise their release in the plan Timeline.',
				role: 'description',
			},
			primaryAction: {
				id: 'jira-plans-release-date-changeboarding.primary-action',
				defaultMessage: 'Got it',
				description: 'Acknowledges and dismisses the release date changeboarding.',
			},
		},
	});
